import React, { useState } from 'react';
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import { SearchIcon } from '@primer/octicons-react'
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const LocPickerDialog = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  const [searchTerms, setSearchTerms] = useState('');
  const [objList,     setObjList]     = useState('');
  const [errMsg,      setErrMsg]      = useState('');


  const onSearchInputChange = (e) => {
    setSearchTerms(e.target.value);
  }


  function renderObj(obj, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{obj.code}</td>
        <td style={{width: "40%"}}>{obj.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => props.handleObjSelect(obj)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }

  const handleObjSearch = (e) => {

    e.preventDefault(); // Prevents the default form submission behavior (page reload)

    if (searchTerms === '') {
      setObjList([]);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
/*
        const queryString = ((props.type && (props.type.length !== '')) ? 'type=' + props.type + '&' : '') +
                            'searchTerms=' + searchTerms;
*/

        let queryString;

        if (props.type && (props.type.length !== '')) {
          queryString = 'type=' + props.type + '&code=' + searchTerms;
        } else {
          queryString = 'searchTerms=' + searchTerms;
        }

        const res = await axiosAuth_DATA_MGMT_API.get("locations?" + queryString);

        resolve(res.data.data)

        if (res.status === 200) {
          if (res.data.total) {
            setObjList(res.data.data);
          } else {
            setObjList(res.data);
          }
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  return (
    <>
      <Modal show={props.show} onHide={props.onClose} centered >
        <Modal.Body>
          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
            <span>
              {t("I18N_Loc_picker")}
            </span>

            <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

            <form onSubmit={handleObjSearch}>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Location_code")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="searchTerms"
                         /* placeholder={t("custom:I18N_Eg_search_loc")} */
                         onChange={(e) => onSearchInputChange(e)} />
                </Col>
                <Col>
                  <span onClick={handleObjSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <SearchIcon size={14} />
                  </span>
                </Col>
              </Row>

              <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

              <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                <Table hover responsive size="sm">
                  <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                    <tr>
                      <th style={{fontWeight:'400'}}>{t("I18N_Location_code")}</th>
                      <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {(objList && objList.length > 0) ? objList.map(renderObj) : null}
                  </tbody>
                </Table>
              </div>

              <Row>
                <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                  {props.extErrMsg ? props.extErrMsg : errMsg}
                </span>
              </Row>
              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={props.onClose}>
                    {t("I18N_Close")}
                  </Button>
                </div>
              </Row>

            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LocPickerDialog;
